export const appEvents = new EventTarget();

export const EXPIRED_SESSION_EVENT = 'expired-session';